<template>
	<div class="mt-5">
		<div class="row">
			<div class="col-md-6">
				<card header-classes="bg-dark">
					<template slot="header">
						<h3 class="mb-0 text-white">Release Notes</h3>
					</template>
					<template>
						<time-line type="one-side">
							<time-line-item badge-type="primary" text="1.0.1">
								<h2 class="d-block mb-3">26 May 2020</h2>
								<!-- <div class="d-flex mb-2">
									<span class="badge badge-success tl-badge">ADDED</span>
									<small class="ml-2">กราฟยอดรวมรายการฝากแต่ละธนาคาร, รายการฝากรายชั่วโมง</small>
								</div>
								<div class="d-flex mb-2">
									<span class="badge badge-success tl-badge">ADDED</span>
									<small class="ml-2">ปรับยอดถอนเป็น 2 เท่าของยอดฝาก</small>
								</div>
								<div class="d-flex mb-2">
									<span class="badge badge-success tl-badge">ADDED</span>
									<small class="ml-2">รองรับ GClub168</small>
								</div>
								<div class="d-flex mb-2">
									<span class="badge badge-success tl-badge">ADDED</span>
									<small class="ml-2">รองรับธนาคารกสิกรไทย (บัญชีฝาก)</small>
								</div>
								<div class="d-flex mb-2">
									<span class="badge badge-warning tl-badge">FIXED</span>
									<small class="ml-2">รายการฝากจากการแนะนำเพื่อนซ้ำ</small>
								</div> -->
							</time-line-item>
						</time-line>
					</template>
				</card>
			</div>
		</div>

		<hr class="mb-3" />
		<h5 class="text-left">Powered by 289 Corporation</h5>
	</div>
</template>

<script>
import { TimeLine, TimeLineItem } from '../components'

export default {
	components: {
		TimeLine,
		TimeLineItem
	}
}
</script>